<template>
  <div>
    <Register />
  </div>
</template>

<script>
import Register from "../components/Register/Register.vue";

export default {
  components: { Register },
};
</script>
